<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row>
              <v-col 
                cols="12"
                class="py-0">
                <v-card v-if="Object.keys(detail).length < 1"
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
  
                <v-card v-if="Object.keys(detail).length > 0"
                  flat>
                  <v-card-text class="px-0">
                    <v-row>
                      <v-col cols="3">
                        <v-img
                          :src="detail.image_url"
                          height="200px"
                          contain
                          class="border-radius">
                        </v-img>
                      </v-col>
                      <v-col cols="9">
                        <div v-if="detail.par_id !== '0'" class="mb-5">
                          <div>
                            Nama Item
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.name }}
                          </div>
                        </div>

                        <!-- <div>
                          <div>
                            Nama <span v-if="detail.par_id === '0'">Item</span> <span v-else>Varian</span>
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.name }}
                          </div>
                        </div> -->

                        <div class="mt-5">
                          <div>
                            Kategori Item
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.category_item_name }}
                          </div>
                        </div>

                        <div class="mt-3">
                          <div>
                            Satuan
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.satuan }}
                          </div>
                        </div>

                        <div class="mt-3">
                          <div>
                            Harga Beli
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.purchase_price | price }}
                          </div>
                        </div>

                        <!-- <div class="mt-3">
                          <div>
                            Deskripsi
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.desc }}
                          </div>
                        </div> -->

                        <div class="mt-3">
                          <div>
                            Catatan
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.note }}
                          </div>
                        </div>
                      </v-col>
                      
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          dialog: {
            fullscreen: false,
            snackbar: false,
  
            role: false
          },
  
          role: [],
  
          list: [],
  
          form: {
            id: '',
            role_id: ''
          },
          
          process: {
            load: false,
  
            role: false,
            form: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      props: {
        detail: {
          type: Object,
          default: {}
        }
      },
      components: {
        
      },
      watch: {
        
      },
      computed: {
        company () {
          return this.$store.state.company
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      beforeMount () {
        // this.fetchDetail()
      },
      mounted () {
        
      },
      methods: {
      }
    }
  </script>